import { colors } from '@material-ui/core';
export default {
  root: {
    color: colors.indigo['500'],
    '&:hover': {
      color: colors.indigo['800'],
    },
  },
};
